// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"styles_cardWrapper__7JXtF","needCollected":"styles_needCollected__usmLg","loadingIndicator":"styles_loadingIndicator__RczRD"};